import Image from "next/image";
import React, { useState } from "react";
import { ScreenSize, useScreen } from "@/hooks/useScreen";

const FEATURES = [
  {
    title: "Inversiones centralizadas",
    content: "Tus inversiones en un solo lugar",
    image: "/features/inversions-dashboard.webp",
  },
  {
    title: "Detalle de tu inversión",
    content: "Consulta el detalle de tu inversión en tiempo real",
    image: "/features/inversion-detail.webp",
  },
  {
    title: "Registro de operaciones",
    content: "Registra las operaciones de compra y venta de tus inversiones",
    image: "/features/inversion-operations.webp",
  },
  {
    title: "Alertas de compras y ventas",
    content: "Recibe avisos cuándo comprar o vender tus inversiones",
    image: "/features/inversion-detail.webp",
  },
  {
    title: "Reglas personalizadas",
    content: "Configura tus reglas de compra y venta a medida",
    image: "/features/manage-rules.webp",
  },
  {
    title: "Simula tu estrategia",
    content:
      "Simula tu estrategia de inversión antes de aplicarla para evitar riesgos",
    image: "/features/simulation-history.webp",
  },
  {
    title: "Indicadores a medida",
    content:
      "Configura tus indicadores técnicos a medida apoyandote en nuestro simulador",
    image: "/features/customize-indicator.webp",
    imagePosition: "bottom",
  },
];

const Feature = (props: any) => {
  const { className, isSelected, onClick, position, screenSize } = props;

  const positionStyles =
    position == "left"
      ? {
          borderLeftWidth: 3,
          paddingLeft: 4,
        }
      : {
          borderRightWidth: 3,
          paddingRight: 4,
        };

  return (
    <div
      className={`${className} cursor-pointer transition-all`}
      style={{
        marginBottom: 8,
        height: 420 / 5 - 8,
        minWidth: screenSize === ScreenSize.sm ? 280 : undefined,
        borderColor: isSelected ? "var(--primary)" : "var(--border-color)",
        ...positionStyles,
      }}
      onClick={onClick}
    >
      <h2 className="uppercase text-sm">{props.title}</h2>
      <p className="line-clamp-2">{props.content}</p>
    </div>
  );
};

const checkIsSelectedFeature = (selectedFeature: any, i: number) => {
  if (selectedFeature == null && i == 0) {
    return true;
  }

  return selectedFeature == i;
};

export const OurPlatform = () => {
  const [selectedFeature, setSelectedFeature] = useState<any>(null);

  const selectedFeatureData = FEATURES[selectedFeature || 0];

  const { screenSize } = useScreen();

  const isSmallScreen =
    screenSize === ScreenSize.sm ||
    screenSize === ScreenSize.md ||
    screenSize === ScreenSize.lg;

  const featuresFirstBlock = isSmallScreen
    ? FEATURES
    : FEATURES.slice(0, Math.ceil(FEATURES.length / 2));

  return (
    <div className="w-full mt-2">
      <h1>Nuestra plataforma</h1>
      <p>
        Descubre todo lo que puedes hacer con Keperin para optimizar y
        automatizar tus inversiones
      </p>
      <div className="grid lg:grid-cols-3 md:grid-cols-2 sm:grid-cols-2 mt-4 justify-center">
        <div
          style={{
            maxHeight: screenSize === ScreenSize.sm ? 420 / 5 : 420,
            overflowX: "auto",
            display : screenSize === ScreenSize.sm ? "flex" : "block"
          }}
          className="max-w-[280px] sm:max-w-[100%]"
        >
          {featuresFirstBlock.map((feature, i) => (
            <Feature
              key={i}
              {...feature}
              className={"mr-2"}
              isSelected={checkIsSelectedFeature(selectedFeature, i)}
              onClick={() => setSelectedFeature(i)}
              position="left"
              screenSize={screenSize}
            />
          ))}
        </div>
        <div
          style={{
            height: 420,
            overflow: "hidden",
            position: "relative",
          }}
        >
          <Image
            src={selectedFeatureData.image}
            fill
            style={{
              objectFit: "contain",
              height: "100%",
              width: "100%",
              objectPosition: selectedFeatureData.imagePosition || "top",
            }}
            alt={selectedFeatureData.title}
            sizes="(max-width: 640px) 100vw,
            (max-width: 1280px) 50vw,
            (max-width: 1536px) 33vw,
            25vw"
          />
        </div>
        <div>
          {!isSmallScreen &&
            FEATURES.slice(Math.floor(FEATURES.length / 2) + 1).map(
              (feature, i) => (
                <Feature
                  key={i}
                  {...feature}
                  className={"ml-2"}
                  isSelected={checkIsSelectedFeature(
                    selectedFeature,
                    i + Math.floor(FEATURES.length / 2) + 1
                  )}
                  onClick={() =>
                    setSelectedFeature(i + Math.floor(FEATURES.length / 2) + 1)
                  }
                  position="right"
                  screenSize={screenSize}
                />
              )
            )}
        </div>
      </div>
    </div>
  );
};
